import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RightOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import * as S from './styles';
import AddressField from '../AddressField';

export default function LocationForm({
  address,
  setAddress,
  position,
  ...props
}) {
  const { canNext, handleNext, invalidMessage } = props;
  const [refPickup, setRefPickup] = useState(null);
  const [refDropoff, setRefDropoff] = useState(null);

  function handlePickupAddress() {
    const place = refPickup?.getPlace();
    if (place && place.formatted_address) {
      handleAddress('pickup', place);
    }
  }

  function handleDropoffAddress() {
    const place = refDropoff?.getPlace();
    if (place && place.formatted_address) {
      handleAddress('dropoff', place);
    }
  }

  function handleAddress(key, place) {
    const lat = place?.geometry?.location?.lat() || 0;
    const lng = place?.geometry?.location?.lng() || 0;
    const placeTypes = place.address_components
      ?.map(({ types }) => types)
      .join();
    const addressIsComplete = ['street_number', 'route'].every((type) =>
      placeTypes.includes(type)
    );
    setAddress({
      ...address,
      [`${key}Detail`]: place,
      [`${key}Failed`]: !addressIsComplete,
      [`${key}Input`]: place.formatted_address,
      [key]: {
        ...address[key],
        address: place.formatted_address,
        hasParking: '1',
        location: { lat, lng },
      },
    });
  }

  function changeAddressInput(e) {
    setAddress({
      ...address,
      [`${e.target.id}Failed`]: null,
      [`${e.target.id}Input`]: e.target.value,
    });
  }

  function clearAddressInput(key) {
    setAddress({
      ...address,
      [`${key}Input`]: '',
      [key]: null,
      [`${key}Failed`]: null,
    });
  }

  return (
    <S.Container className="mm-location-form">
      <S.SearchInnerWrapper>
        <div>
          <AddressField
            id="pickup"
            position={position}
            address={address}
            setRef={setRefPickup}
            setPlace={handlePickupAddress}
            placeholder="model.pickupAddress"
            changeAddressInput={changeAddressInput}
            clearAddressInput={clearAddressInput}
            icon={<S.Icon src="/icons/origin.svg" />}
          />
          <AddressField
            id="dropoff"
            position={position}
            address={address}
            setRef={setRefDropoff}
            placeholder="model.dropoffAddress"
            setPlace={handleDropoffAddress}
            changeAddressInput={changeAddressInput}
            clearAddressInput={clearAddressInput}
            icon={<S.Icon src="/icons/destination.svg" />}
          />
        </div>
        <div>
          {!invalidMessage ? null : <S.Alert>{invalidMessage}</S.Alert>}
          <S.Button
            disabled={canNext}
            onClick={handleNext}
            className="mm-location-form-next"
          >
            <FormattedMessage id="action.next" />
            <RightOutlined />
          </S.Button>
        </div>
      </S.SearchInnerWrapper>
    </S.Container>
  );
}
